import { Component, Input, Output, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { Router, ROUTER_DIRECTIVES, ActivatedRoute } from '@angular/router';
import { AirportService } from '../airports/airport.service';
import { QueryReportListRequest, IQueryReportListColumnResponse, IOperation} from  './query-report';
import { IScenario, ScenarioService } from '../scenario-activities/scenario.service';
import { IQueryReportResponse, IQueryReportRequest, IQueryReportListComponent, IQueryReportsFacilityRequest } from './query-report'
import { UserInfoService } from '../shared/user-info.service';
import { QueryReportService } from './query-report.service';
import { UserSession } from '../shared/user-session';
import { Button } from 'primeng/primeng';
import { Checkbox } from 'primeng/primeng';
import * as _ from 'lodash';

import { Dialog } from 'primeng/primeng';
import {Messages} from 'primeng/primeng';
import {SystemControl} from '../shared/system-control';
import {SystemControlElem} from '../shared/system-control-elem';
import { SystemControlService} from '../shared/system-control.service';

@Component({
    selector: 'query-reports-graph-selections',
    template: require('./query-reports-graph-selections.component.html'),
    styles: [require('../styles/faa_styles.css')],
    directives: [Button, Checkbox]
})

export class QueryReportGraphSelectionsComponent implements OnInit, OnDestroy{
    //@Input() operation: IOperation;
    @Input() selected: boolean;
    @Input() locId: string;
    @Input() airportName: string;
    @Input() displayAll: boolean;

    
    //columns: IOperationListColumnResponse[];
    msgs: Messages[]=[];
    errorMessage: string;
    systemControlElem: SystemControlElem;
    
    startYears:number[] = [];
    endYears:number[] = [];

    selectedStartYear: number;
    selectedEndYear: number;
    graphType: string = "Line";
    yearsToPreview: number = 4;
    hasData: boolean;
    dataCheckDone: boolean = false;
    columns: IQueryReportListColumnResponse[];
    private sub: any; 
    tableId: string;
    endYear:number;
    startYear:number;
    scenario:number;
    tableName:string;
    tableDisplayName: string;
    allOperations: IOperation[];
    currentScenario: IScenario;
    allScenarios: IScenario[];
    scenarioHeaderDiv: HTMLDivElement;
    isScenarioOwner: boolean = false;
    facReportListResponse : IQueryReportResponse[];
    displaySpinner :boolean=false;
    cols: any[];
    constructor(private route: ActivatedRoute,
                private router: Router,
                private _airportService: AirportService,
                private _queryReportService: QueryReportService,  
                private _scenarioService: ScenarioService,
                private _userInfoService: UserInfoService, 
                private User: UserSession,
                private request: QueryReportListRequest,
                private _systemControlService:SystemControlService) 
    {}
    @ViewChild('scenarioHeader') scenarioHeader: ElementRef;

    ngOnInit(): void{
        this.scenarioHeaderDiv = this.scenarioHeader.nativeElement;
        this._scenarioService.getScenarios(this.User.getSession()['id'])
            .subscribe(
                scenarios => this.allScenarios = scenarios,
                error => this.errorMessage = <any>error,
                () => {
                    this.setScenarioHeader(this.User.getSession().scenarioId);
                }
            );
        
        //this probably needs to be somewhere more central
        this.User.updateSessionState();
        
        this._userInfoService.isScenarioOwner(this.User.getSession()['id'], this.User.getSession().scenarioId).subscribe(
            success => this.isScenarioOwner = success.isOwner,
            error => this.errorMessage = <any>error
        );

        this.sub = this.route.params.subscribe(
            params => {
                this.tableId = params['tableId'];
                this.startYear = params['startYear'];
                this.endYear = params['endYear'];
                this.scenario = params['scenario'];
                switch (this.tableId) {
                    case "0":
                    {
                        this.tableName='AirportOperations';
                        this.tableDisplayName='Airport Operations';
                        break;
                    }
                    case "1":
                    {
                        this.tableName='Basedaircraft';
                        this.tableDisplayName='Based Aircraft';
                        break;
                    }
                    case "2":
                    {
                        this.tableName='Enplanements';
                        this.tableDisplayName='Enplanements';
                        break;
                    }
                    case "3":
                    {
                        this.tableName='traconops';
                        this.tableDisplayName='Tracon Operations';
                        break;
                    }
                    default:
                        break;
                }
                this.getColumns();
               
            });
    }
    private setScenarioHeader(scenarioId: number):void {
        let foundScenarios:IScenario[] = this.allScenarios.filter(function(scenario){
            return scenario.id === scenarioId;
        });
        if(foundScenarios.length > 0){
            this.currentScenario = foundScenarios[0];
        }
        this.scenarioHeaderDiv.innerHTML = `<strong>Current Scenario: ${this.currentScenario.scenarioName} (${this.currentScenario.id})</strong>`;
    }

    
    getColumns(){
        //reusing airports code
        this.request.tableName = this.tableName;
        this.request.scenario = this.User.getSession().scenarioId;
        this.request.isAdmin = this.User.getSession().isAdmin ? 1 : 0;
        this._airportService.getOperationsColumns(this.request)
                .subscribe(
                    columns => this.columns = columns,
                    error => this.errorMessage = <any>error);
    }

    getSystemControlValues(){
        this._systemControlService.getSystemControl()
            .subscribe(
                systemControlElem => {
                    this.systemControlElem = systemControlElem;
                },
                error => this.errorMessage = <any>error);
    }
    cancel(){
        this.router.navigate([`/query-reports`]);
    }
    ngOnDestroy(){}

    generateGraph(){
        this.displaySpinner =true;
        let selectedColumns = this.columns.filter(function(column){
            return column.graphR == 1;
        });
        if(selectedColumns.length === 0){
            this.msgs=[];
            this.msgs.push({severity:'error', summary:'Error Message', detail: 'At least one data column must be selected.' });
            return;
        }
        
        sessionStorage.setItem('operations-graph-columns', JSON.stringify(selectedColumns));

    /*    let params = {
            displayName: this.tableDisplayName,
            tableName:this.tableName,
            locId: 0, //pass sin 0 to run graphs for entire scenario
            airportName: '',
            graphType: this.graphType,
            startYear: this.startYear,
            endYear: this.endYear,
            quickGraph: "false",
            reportId: this.request
        };*/
        this.request.graphType = this.graphType;
        this.request.scenarioId = this.scenario;
        this.request.startYear = this.startYear;
        this.request.reportId = 8; //produce graphs
        this.request.columns = JSON.parse(sessionStorage.getItem('operations-graph-columns'));
       
        
        this._queryReportService.getFacilityListReport(this.request)
                .subscribe(
                response => {
                   this.displaySpinner = false;
                    this.facReportListResponse = response;
                    if (this.facReportListResponse[0].responseStatus === 'ERROR') {
                        this.msgs=[];
                        this.msgs.push({severity:'error', summary:'Error Message', detail: 'An error has occurred executing your request'
                                        +this.facReportListResponse[0].responseMessage});
                    }
                    else if (this.facReportListResponse[0].responseMessage === 'No Data') {
                        this.msgs=[];
                        this.msgs.push({severity:'error', summary:'Info Message', detail: 'No Data returned.'
                                        +this.facReportListResponse[0].responseMessage});
                        this.facReportListResponse[0].pdfFileUrl="";
                        this.facReportListResponse[0].htmlFileUrl="";
                    }
                    else{
                        this.msgs=[];
                        this.msgs.push({severity:'info', summary:'Info Message', detail: 'PDF & HTML file generated; please click links below' });
                        this.cols = [
                                    {field: "htmlFileUrl", header: 'Html'},
                                    {field: "pdfFileUrl", header: 'Pdf'},
                        ]
                    }
                    //console.log ("response facility report " + this.facReportListResponse[0].htmlFileUrl + "  " 
                    //                + this.facReportListResponse[0].pdfFileUrl +" " + this.facReportListResponse[0].responseMessage +" "
                    //                + this.facReportListResponse[0].responseStatus +" " + this.facReportListResponse[0].responseDisplay)
                },
                error => this.errorMessage = <any>error
                );
        //this.router.navigate([`/query-reports-graph-display`, params]);
    }
    openPDFFile(responsepdf:any){
        window.open(responsepdf, '_blank');
    }
    openHTMLFile(responseHtml:any){
        window.open(responseHtml, '_blank');
    }
}




/** WEBPACK FOOTER **
 ** ./app/query-reports/query-reports-graph-selections.component.ts
 **/